// Piezas de formulario compartidas por Reservas y Eventos.
import type { ReactNode } from 'react';
import { btnSecundario } from '../../components/ui/estilos';

export const entrada: React.CSSProperties = {
  width: '100%', height: 48, padding: '0 14px', borderRadius: 10, border: '1px solid var(--line-strong)',
  fontSize: 16, background: 'var(--surface)', color: 'var(--ink)',
};

export function Campo({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
      <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--muted)' }}>{label}</span>
      {children}
    </label>
  );
}

export function Contador({ valor, onCambio, min = 1, max = 500, label }: { valor: number; onCambio: (n: number) => void; min?: number; max?: number; label: string }) {
  const b: React.CSSProperties = { ...btnSecundario, width: 44, height: 44, padding: 0, fontSize: 20 };
  return (
    <div role="group" aria-label={label} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <button type="button" onClick={() => onCambio(Math.max(min, valor - 1))} aria-label="Menos" style={b}>−</button>
      <div aria-live="polite" style={{ flex: 1, textAlign: 'center', fontSize: 18, fontWeight: 700 }}>{valor}</div>
      <button type="button" onClick={() => onCambio(Math.min(max, valor + 1))} aria-label="Más" style={b}>+</button>
    </div>
  );
}

export const dosColumnas: React.CSSProperties = { display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)', gap: 12 };

export const tarjetaLista = (on: boolean): React.CSSProperties => ({
  textAlign: 'left', padding: '14px 16px', borderRadius: 14, cursor: 'pointer', color: 'var(--ink)',
  border: on ? '2px solid var(--brand-texto)' : '1px solid var(--line)', background: on ? 'var(--well)' : 'var(--surface)',
  display: 'flex', flexDirection: 'column', gap: 6,
});
